const moduloVMI = {
  url: {
    administracion: {
      integrador: 'integrador',
      articulos: 'articulo',
      amortiguador: 'amortiguador',
      tanques: 'tanque',
      clientes: 'cliente',
      colorPorcentaje: 'color',
      usuarios: 'usuario',
      alertas: 'color-alerta',
      reporteDiario: 'reporteDiario',
      refrescamientoTanque: 'refrescamientoTanque',
      rol: 'rol',
    },
    informes: {
      estadoProducto: 'vmi-nucleo/cliente',
      estadoProductoGetAll: 'vmi-nucleo/getall',
      //*
      penetracionRawLegacy: 'vmi-nucleo/legacy/raw',
      penetracionFiltradoLegacy: 'vmi-nucleo/legacy/filtrado',
      penetracionRaw: 'vmi-nucleo/raw',
      penetracionFiltrado: 'vmi-nucleo/filtrado',
      penetracionFiltradoPdf: 'vmi-nucleo/pdf',
      penetracionSegumiento: 'pedido/drivin',
      penetracionSegumientoRaw: 'pedido/drivin-widget',
      ordenesFecha: 'pedido/ordenesFecha',
      factura: 'pedido/factura'
    }
  },
  button: {
    buttonsCss: {
      primary: 'btn btn-primary btn-block',
      secondary: 'btn btn-secondary btn-block',
      success: 'btn btn-success btn-block',
      danger: 'btn btn-danger btn-block',
      warning: 'btn btn-warning btn-block',
      info: 'btn btn-info btn-block',
      light: 'btn btn-light btn-block',
      dark: 'btn btn-dark btn-block',
      primaryOutline: 'btn btn-outline-primary',
      secondaryOutline: 'btn btn-outline-secondary',
      successOutline: 'btn btn-outline-success',
      dangerOutline: 'btn btn-outline-danger',
      warningOutline: 'btn btn-outline-warning',
      infoOutline: 'btn btn-outline-info',
      lightOutline: 'btn btn-outline-light',
      darkOutline: 'btn btn-outline-dark'
    },
    buttonsNombre: {
      editar: 'Editar',
      eliminar: 'Eliminar',
      agregar: 'Agregar ',
      guardar: 'Guardar',
      actualizar: 'Actualizar',
      mostrar: 'Mostrar seleccion',
      regresar: 'Regresar',
      continuar: 'Continuar',
      seleccionar: 'Seleccionar',
      ver: 'Ver'
    }
  },
  mensajes: {
    errorServicio: 'error..!!',
    desabilitada: 'Opción desabilitada',
    eliminar: '¿Está seguro que desea eliminar el siguiente elemento?',
    guardar: '¿Está seguro que desea guardar el siguiente elemento?',
    actualizar: '¿Está seguro que desea actualizar el siguiente elemento?',
    datoGuardado: 'Se guardo corectamsente..!!',
    guardarParada: 'Está seguro que desea registrar este evento..??',
    secuencialParada: '¿Está seguro que desea actualizar los campos de F.Inicio, F.Fin, Contadores y Rechazo de los siguientes elementos?',
  },
  titulos: {
    articulo: {
      titulo: 'Artículos',
      modulo: 'VMI',
      nuevo: 'Nuevo Artículo',
      listaVacia: 'No se encontraron datos para la lista de Artículos.',
      tituloCardListar: 'Lista de Artículos',
      tituloCardGuardar: 'Guardar Artículo',
      tituloCardEditar: 'Editar Artículo'
    },
    integrador:{
      titulo: 'Usuario Integración',
      modulo: 'VMI',
      nuevo: 'Nuevo Registro',
      listaVacia: 'No se encontraron datos para la lista de Usuarios Integrados.',
      tituloCardListar: 'Lista de Usuarios',
      tituloCardGuardar: 'Guardar Registro',
      tituloCardEditar: 'Editar Registro'
    },
    amortiguador: {
      titulo: 'Amortiguador',
      modulo: 'VMI',
      nuevo: 'Nuevo Amortiguador',
      listaVacia: 'No se encontraron datos para la lista de Amortiguadores.',
      tituloCardListar: 'Lista de Amortiguadores',
      tituloCardGuardar: 'Guardar Amortiguador',
      tituloCardEditar: 'Editar Amortiguador'
    },
    tanques: {
      titulo: 'Tanques',
      modulo: 'VMI',
      nuevo: 'Nuevo Tanque',
      listaVacia: 'No se encontraron datos para la lista de Tanques.',
      tituloCardListar: 'Lista de Tanques',
      tituloCardGuardar: 'Guardar Tanque',
      tituloCardEditar: 'Editar Tanque'
    },
    clientes: {
      titulo: 'Clientes',
      modulo: 'VMI',
      nuevo: 'Nuevo Cliente',
      listaVacia: 'No se encontraron datos para la lista de Clientes.',
      tituloCardListar: 'Lista de Clientes',
      tituloCardGuardar: 'Guardar Cliente',
      tituloCardEditar: 'Editar Cliente'
    },
    colorPorcentaje: {
      titulo: 'Color Porcentaje',
      modulo: 'VMI',
      nuevo: 'Nuevo Color Porcentaje',
      listaVacia: 'No se encontraron datos para la lista de Colores Porcentaje.',
      tituloCardListar: 'Lista de Colores Porcentajes',
      tituloCardGuardar: 'Guardar Color Porcentaje',
      tituloCardEditar: 'Editar Color Porcentaje'
    },
    usuarios: {
      titulo: 'Usuarios',
      modulo: 'VMI',
      nuevo: 'Nuevo Usuario',
      listaVacia: 'No se encontraron datos para la lista de Usuarios.',
      tituloCardListar: 'Lista de Usuarios',
      tituloCardGuardar: 'Guardar Usuario',
      tituloCardEditar: 'Editar Usuario'
    },
    alertas: {
      titulo: 'Alertas',
      modulo: 'VMI',
      nuevo: 'Nuevo Alertas',
      listaVacia: 'No se encontraron datos para la lista de Alertas.',
      tituloCardListar: 'Lista de Alertas',
      tituloCardGuardar: 'Guardar Alerta',
      tituloCardEditar: 'Editar Alerta'
    },
    reporteDiario: {
      titulo: 'Reporte Diario',
      modulo: 'VMI',
      nuevo: 'Nuevo Reporte Diario',
      listaVacia: 'No se encontraron datos para la lista de Reportes Diario.',
      tituloCardListar: 'Lista de Reportes Diario',
      tituloCardGuardar: 'Guardar Reporte Diario',
      tituloCardEditar: 'Editar Reporte Diario'
    },
    refrescamientoTanque: {
      titulo: 'Refrescamiento Tanque',
      modulo: 'VMI',
      nuevo: 'Nuevo Refrescamiento Tanque',
      listaVacia: 'No se encontraron datos para la lista de Refrescamiento Tanque.',
      tituloCardListar: 'Lista de Refrescamiento Tanque',
      tituloCardGuardar: 'Guardar Refrescamiento Tanque',
      tituloCardEditar: 'Editar Refrescamiento Tanque'
    },
    estadoProducto: {
      titulo: 'Reporte Estado Producto',
      modulo: 'VMI',
      // nuevo: 'Nuevo Refrescamiento Tanque',
      listaVacia: 'No se encontraron datos',
      tituloCardListar: 'Estado Producto'

    },
    penetracion: {
      titulo: 'Reporte %Penetración',
      modulo: 'VMI',
      // nuevo: 'Nuevo Refrescamiento Tanque',
      listaVacia: 'No se encontraron datos',
      tituloCardListar: '%Penetración'

    }
  },
  agGrid: {
    paginacion: 10,
    paginacionPareto: 100,
    id: 'myGrid',
    class: 'ag-theme-alpine mt-3',
    style: {
      width: '100%',
      height: '600px'
    }
  },
  agGridModal: {
    paginacion: 10,
    paginacionPareto: 100,
    id: 'myGrid',
    class: 'ag-theme-alpine mt-3',
    style: {
      width: '100%',
      height: '400px'
    }
  },
  div: {
    resposiveFull: 'col-12 col-sm-6 col-md-6 col-lg-4 ',//verificar el tipo de pantalla
  },
  toltipOptions: {
    'placement': 'left',
    'showDelay': 500
  }

}

export {moduloVMI}
